<ng-container [formGroup]="stepForm">
  <mat-form-field appearance="outline" class="text-grey password-form-field" [hideRequiredMarker]="true">
    <mat-label>Nowe hasło</mat-label>
    <input
      matInput
      [type]="passwordVisible ? 'text' : 'password'"
      [formControl]="password"
      name="password"
      (keydown.enter)="onSubmit()"
      autocomplete="password"
      tabindex="0"
      appGtmFormEvent
      [eventField]="'password'"
      [eventForm]="formName"
    />
    <button
      matSuffix
      mat-icon-button
      type="button"
      class="password-visibility-btn"
      [matTooltip]="passwordVisible ? 'Ukryj hasło' : 'Pokaż hasło'"
      (click)="passwordVisible = !passwordVisible">
      <app-icon
        [name]="passwordVisible ? 'visibility_off_filled' : 'visibility_filled'"
        color="rgba(0,0,0,.5)"
        size="20"
        matSuffix
      ></app-icon>
    </button>
  </mat-form-field>

  <div class="password-help">
    <app-password-meter
      [password]="password.value"
      [color]=" 'primary'"
    ></app-password-meter>
  </div>

  <mat-error *ngFor="let error of errors" class="error-message status-error">
    {{ errorMessages[error] }}
  </mat-error>
  <div class="actions">
    <app-new-loader-button
      [disabled]="loading ||  (submitted && !stepForm.valid)"
      (buttonClick)="onSubmit()"
      [loading]="loading"
      class="auth-button"
      id="register-button"
      [customType]="LoaderButtonType.RAISED"
      color="accent">
      Dalej
    </app-new-loader-button>
  </div>
</ng-container>
